import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  // Check if user is logged in by looking for the 'user' item in localStorage
  const userInfo = JSON.parse(localStorage.getItem('user'));

  // If user info (and token) exists, render the child route (Outlet)
  // Otherwise, redirect to the /login page
  return userInfo ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;